import api from '~/state/api/index';
import ui from '~/state/ducks/ui/actions';
import mapping from '~/utils/mapping.json';


const getRoleName = (id, count) => `${mapping.roles.by_id[id]}${count !== 1 ? 's' : ''}`;

export const transform = (users = []) => {
    const rolesCount = Object.keys(mapping.roles.by_id).reduce((obj, i) => {
        obj[i] = 0;
        return obj;
    }, {});

    let userList;

    if (Array.isArray(users.Body)) {
        userList = users.Body;
    } else if (Array.isArray(users)) {
        userList = users;
    } else {
        userList = [];
    }

    userList.forEach(({ role_id }) => {
        rolesCount[role_id]++;
    });

    return Object.entries(rolesCount).map(([id, count]) => ({
        role: getRoleName(id, count),
        count,
    }));
};

export const fetchOrganizationUsersStats = id => async (dispatch) => {

    try {
        const { data } = await dispatch(api.get(`/organizations/${id}/users`, {
            params: {
                limit: -1,
            },
        }));

        return transform(data);

    } catch (error) {
        dispatch(ui.flash.error({ header: 'Failed to fetch users stats' }, error));
    }
};
